import React from 'react'
import { Dejargonator, TextBody } from '@ally/metronome-ui'
import { AccountDetails } from '../../../types'
import {
  AcctDetailsItem,
  Dt,
  Dd,
  StyledDejargTrigger,
} from './StyledDlElements'
import { amountFormatter } from '../../../utils/formatter'

interface CurrentRedemptionAmountDlProps {
  account: AccountDetails
}

export const CurrentRedemptionAmountDl: React.FC<CurrentRedemptionAmountDlProps> =
  ({ account }) => {
    if (!account || typeof account.currentRedemptionAmt !== 'number') {
      return null
    }

    return (
      <AcctDetailsItem>
        <Dt>
          <Dejargonator
            trigger={{
              content: (
                <StyledDejargTrigger>
                  <TextBody size="sm" tag="span" weight="bold">
                    Current Redemption Amt:
                  </TextBody>
                </StyledDejargTrigger>
              ),
              variant: 'element',
              ariaLabel: 'current redemption amount',
            }}
            body="Current Redemption Amount is the amount you'll receive if you cash in this CD today, rather than on the maturity date. Keep in mind, this amount is an estimate that could change if you're in your grace period. Interest will accrue during the grace period but will not be paid if the funds are withdrawn."
            ariaLabelPopover="Current Redemption Amount is the amount you'll receive if you cash in this CD today, rather than on the maturity date."
          />
        </Dt>
        <Dd>{amountFormatter.format(account.currentRedemptionAmt)}</Dd>
      </AcctDetailsItem>
    )
  }
